import { OrderDetailsView } from '@nexelem/graphne-api';

export const hasComment = (orders?: OrderDetailsView[]): boolean => !!orders?.some((order) => order.comment);
